l<template>
	<div class="relative">
		<form id="mc-form" action="//performa-arts.us1.list-manage.com/subscribe/post?u=d0c64ea1766aa8d13da890df0&amp;id=537e8220a2">
			<div class="relative input-group">
		        <input id="mc-email" type="email" placeholder="email ..."  autocomplete="off">
		        <button class="old-btn btn" type="submit">Submit</button>
	    	</div>
	        <label for="mc-email"></label>
	    </form>
	</div>

</template>

<script>
	export default {
		name: 'Mailchimp'
	}
</script>

<style>
@media only screen and (min-width: 48em){

#mc-form button{
		right: 1em !important;
		bottom: 0em !important;
	}
	
}
	
</style>
